import type { PagedResultDto } from "@services/dto/pagedResultDto"
import towerService from "@services/master-data/towerService"
import { action, makeAutoObservable, observable } from "mobx"
import { appDataStoreInstance as appDataStore } from "../appDataStore"

class TowerStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any

  constructor() {
    makeAutoObservable(this)
    this.tableData = { items: [], totalCount: 0 }
  }

  @action
  async createOrUpdate(body: any) {
    this.isLoading = true
    const result = await towerService
      .createOrUpdate(body)
      .finally(() => (this.isLoading = false))
    this.detailData = result
    if (!body.id) {
      this.tableData.items.push(result)
    } else {
      this.tableData.items = this.tableData.items.map((x) => {
        if (x.id === body.id) x = result
        return x
      })
    }
    appDataStore.getListTower()
  }

  @action
  async newTownShip() {
    this.detailData = {
      id: 0,
    }
  }

  @action
  async active(id: number, isActive) {
    this.isLoading = true
    await towerService
      .activate(id, isActive)
      .finally(() => (this.isLoading = false))
    appDataStore.getListTower()
  }

  @action
  async get(id: number) {
    this.isLoading = true
    const result = await towerService
      .get(id)
      .finally(() => (this.isLoading = false))
    this.detailData = result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await towerService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }
  @action
  async exportExcel(params: any, name: any = "tower") {
    this.isLoading = true
    return await towerService
      .exportExcel(params, name || "tower")
      .finally(() => (this.isLoading = false))
  }
  @action
  public import = async (file: File) => {
    this.isLoading = true
    try {
      const result = await towerService
        .importTower(file)
        .finally(() => (this.isLoading = false))

      appDataStore.getListTower()
      return result
    } catch (error) {
      this.isLoading = false
      throw error
    }
  }
}

export default TowerStore
